"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logMissingConceptOrName = exports.MISSING_NAME = exports.MISSING_CONCEPT = void 0;
const MISSING_CONCEPT = exports.MISSING_CONCEPT = 'Missing product concept';
const MISSING_NAME = exports.MISSING_NAME = 'Missing product name';
const logMissingConceptOrName = ({
  logger,
  data
}) => {
  if (!logger) {
    return;
  }
  const {
    concept
  } = data;
  const {
    name
  } = concept ?? {};
  if (!concept) {
    logger.warn(MISSING_CONCEPT, {
      data: JSON.stringify(data)
    });
  } else if (!name) {
    logger.warn(MISSING_NAME, {
      data: JSON.stringify(data)
    });
  }
};
exports.logMissingConceptOrName = logMissingConceptOrName;
//# sourceMappingURL=logMissingConceptOrName.js.map